<template>
  <div>
    <div class="mb-4">
      <h3 class="font-weight-bold mt-1 fs-large">
        {{ productDetails.name }}
      </h3>
    </div>
    <!-- add to favourite -->

    <div v-if="isUserFavourited" class="mb-4" @click="removeFromFavourites">
      <div v-if="!favouriteLoading" class="d-flex align-center pointer">
        <v-icon class="mainFont--text ">$FilledHeart</v-icon>
        <span class="ms-1 mainFont--text pointer"> حذف از علاقه‌مندی‌ها</span>
      </div>
      <div v-else>
        <v-progress-circular indeterminate color="primary" size="20" />
      </div>
    </div>
    <div v-else class="mb-4" @click="addToFavourites">
      <div v-if="!favouriteLoading" class="d-flex align-center pointer">
        <v-icon class="mainFont--text">$Heart</v-icon>
        <span class="ms-1 mainFont--text pointer">
          افزودن به علاقه‌مندی‌ها</span
        >
      </div>
      <div v-else>
        <v-progress-circular indeterminate color="primary" size="20" />
      </div>
    </div>
    <h3 class="fs-large font-weight-bold mr-4">مشخصات</h3>

    <div
      class="mt-4 mr-2 d-flex align-center"
      v-if="productDetails.publisherName"
    >
      <div class="d-flex align-center ml-2">
        <v-icon class="grey--text me-1" x-small>mdi-circle</v-icon>
        <span class="mainFont--text">ناشر:</span>
      </div>

      <span>
        <a
          :href="'/store/publisher=' + productDetails.publisherId"
          target="_blank"
          rel="noopener noreferrer"
          style="z-index: 100"
        >
          {{ productDetails.publisherName }}
        </a>
      </span>
    </div>
    <div class="mt-4 mr-2 line-authors" v-if="authorsName.length">
      <div class="d-flex align-center ml-2">
        <v-icon class="grey--text me-1" x-small>mdi-circle</v-icon>
        <span class="mainFont--text" v-if="authorsName.length == 1"
          >نویسنده:</span
        >
        <span class="mainFont--text" v-else-if="authorsName.length > 1"
          >نویسندگان:</span
        >
      </div>

      <div
        v-for="(item, index) in authors"
        :key="index"
        class="item-line-authors"
      >
        <span>
          <a
            :href="'/store/author=' + item.id"
            target="_blank"
            rel="noopener noreferrer"
            style="z-index: 100"
          >
            {{ item.name }}
            <span v-if="index < authors.length - 1"> ، </span>
          </a>
        </span>
        <!-- <span class="mainFont--text">{{ item }}</span>
        <span v-if="index < authorsName.length - 1"> ، </span> -->
      </div>
    </div>
    <div class="mt-4 mr-2 d-flex align-center" v-if="productDetails.subject">
      <div class="d-flex align-center ml-2">
        <v-icon class="grey--text me-1" x-small>mdi-circle</v-icon>
        <span class="mainFont--text">موضوع:</span>
      </div>
      <span class="primary--text">
        {{ productDetails.subject }}
      </span>
    </div>
    <div
      class="mt-4 mr-2 d-flex align-center"
      v-if="productDetails.publishYear"
    >
      <div class="d-flex align-center ml-2">
        <v-icon class="grey--text me-1" x-small>mdi-circle</v-icon>
        <span class="mainFont--text">سال چاپ:</span>
      </div>
      <span class="primary--text">
        {{ productDetails.publishYear }}
      </span>
    </div>
    <div
      class="mt-4 mr-2 d-flex align-center"
      v-if="productDetails.educationalStage"
    >
      <div class="d-flex align-center ml-2">
        <v-icon class="grey--text me-1" x-small>mdi-circle</v-icon>
        <span class="mainFont--text">پایه:</span>
      </div>
      <span class="primary--text">
        {{ productDetails.educationalStage }}
        {{ productDetails.major ? productDetails.major : "" }}
      </span>
    </div>

    <div
      class="mt-4 mr-2 d-flex align-center"
      v-if="productDetails.divisionName"
    >
      <div class="d-flex align-center ml-2">
        <v-icon class="grey--text me-1" x-small>mdi-circle</v-icon>

        <span class="mainFont--text">سری:</span>
      </div>
      <span class="mainFont--text">
        <a
          :href="'/store/division=' + productDetails.divisionId"
          target="_blank"
          rel="noopener noreferrer"
          style="z-index: 100"
        >
          {{ productDetails.divisionName }}
        </a>
      </span>
    </div>

    <v-divider />
    <h3 class="fs-large font-weight-bold mr-4">توضیحات</h3>
    <div class="mt-4" v-if="productDetails.description">
      <span class="fs-medium font-weight-bold mainFont--text">
        {{ productDetails.description }}
      </span>
    </div>
    <div class="mt-4" v-if="productDetails.onlineShopDescription">
      <span class="fs-medium font-weight-bold mainFont--text">
        {{ productDetails.onlineShopDescription }}
      </span>
    </div>
    <div v-if="productDetails.tags && productDetails.tags.length" class="mt-4">
      <span class="mainFont--text fs-medium mr-4">کلیدواژه‌ها:</span>
      <div class="d-flex tags flex-wrap">
        <div
          v-for="(tag, index) in productDetails.tags"
          :key="index"
          class="purple-badge ms-1 me-1 mt-2"
        >
          {{ tag }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";

export default {
  name: "ProductInfo",
  props: ["productDetails", "authorsName", "authorsId","authors"],

  data() {
    return {
      isUserFavourited: false,
      favouriteLoading: false,
    };
  },
  methods: {
    removeFromFavourites() {
      this.favouriteLoading = true;
      Axios.patch(
        this.baseUrl +
          "/onlineShop/item/removeFavourite/" +
          this.$route.params.id,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          this.favouriteLoading = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.favouriteLoading = false;

            this.isUserFavourited = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.favouriteLoading = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.favouriteLoading = false;
        });
    },
    addToFavourites() {
      this.favouriteLoading = true;
      Axios.patch(
        this.baseUrl + "/onlineShop/item/addFavourite/" + this.$route.params.id,
        {
          itemId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          this.favouriteLoading = false;

          if (res.status == 200) {
            this.isUserFavourited = true;
            this.toast(res.data.message, "success");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.favouriteLoading = false;

          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },
  mounted() {
    this.isUserFavourited = this.productDetails.isUserFavourited;
  },
};
</script>

<style lang="scss">
.line-authors {
  display: flex;
  flex-wrap: wrap;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    justify-content: flex-start;
  }
}
.item-line-authors {

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  @media only screen and (max-width: 600px) {
    margin-right: 20px;
  }
}
</style>
